module.exports = __webpack_public_path__ + "img/pr-11.8aecb05d.png";